/* Shared helper. Only active where the rollout B CSS sets --lily-fewer-colors: 1.
 * Prepared against Lily's public markup on 2026-09-18; verify in Shopify preview.
 */
(() => {
  'use strict';
  const productSelector = 'form[data-instant-form-product-id="15286852223311"]';
  const hiddenColor = /^(Champagne lux|Vulkanask)/i;

  function initialize() {
    const form = Array.from(document.querySelectorAll(productSelector))
      .find(candidate => candidate.querySelector('.instant-variant-picker input[type="radio"]'));
    if (!form) return;

    form.removeAttribute('data-lily-colors-ready');
    if (getComputedStyle(form).getPropertyValue('--lily-fewer-colors').trim() !== '1') return;

    const layout = form.closest('[data-instant-layout="PRODUCT_TEMPLATE"]');
    const data = layout?.querySelector('script[type="application/json"][id^="variants__"]');
    if (!data) return;

    let variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (_) {
      return;
    }
    if (!Array.isArray(variants)) return;

    const url = new URL(window.location.href);
    const requestedId = url.searchParams.get('variant');
    const requested = variants.find(variant => String(variant.id) === requestedId);
    const checked = Array.from(form.querySelectorAll('.instant-variant-picker input[type="radio"]:checked'));
    const blockedSelection = checked.some(input => hiddenColor.test(input.value));

    if ((requested && hiddenColor.test(requested.option1 || '')) || blockedSelection) {
      const allowed = variants.filter(variant => variant.available === true &&
        !hiddenColor.test(variant.option1 || ''));
      const fallback = allowed.find(variant => variant.option1 === 'Onyx') || allowed[0];
      // Keep the original controls if no valid fallback exists; never hide a selected color.
      if (!fallback || String(fallback.id) === requestedId) return;
      url.searchParams.set('variant', String(fallback.id));
      // Keep campaign parameters, selling_plan, locale path and hash.
      // Reload through Shopify so Instant initializes its image, price and cart state together.
      window.location.replace(url.href);
      return;
    }

    if (!checked.length) return;
    form.setAttribute('data-lily-colors-ready', '');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  window.addEventListener('pageshow', initialize);
  document.addEventListener('change', event => {
    if (event.target instanceof HTMLInputElement && event.target.type === 'radio' &&
        event.target.closest(productSelector)) {
      requestAnimationFrame(initialize);
    }
  });
})();